import { render, staticRenderFns } from "./EmployersPage.vue?vue&type=template&id=50bb93c8&scoped=true&"
import script from "./EmployersPage.vue?vue&type=script&lang=ts&"
export * from "./EmployersPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmployersPage.vue?vue&type=style&index=0&id=50bb93c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb93c8",
  null
  
)

export default component.exports